import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TripProtectionBannerComponent } from './trip-protection-banner.component';

@NgModule({
  declarations: [TripProtectionBannerComponent],
  imports: [CommonModule],
  exports: [TripProtectionBannerComponent],
  bootstrap: [TripProtectionBannerComponent]
})
export class TripProtectionBannerModule {}
